import { render, staticRenderFns } from "./Acuerdos.vue?vue&type=template&id=727b1827&scoped=true"
import script from "./Acuerdos.vue?vue&type=script&lang=js"
export * from "./Acuerdos.vue?vue&type=script&lang=js"
import style0 from "./Acuerdos.vue?vue&type=style&index=0&id=727b1827&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727b1827",
  null
  
)

export default component.exports